import { useState } from 'react'
import { Button } from 'shared/components/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from 'shared/components/ui/dialog'
import { Textarea } from 'shared/components/ui/textarea'
import { useTranslate } from 'shared/lib/i18n'

export function RejectDialog({
	onReject,
	pending,
}: {
	onReject: (reason: string) => void
	pending: boolean
}) {
	const [open, setOpen] = useState(false)
	const [reason, setReason] = useState('')
	const { prefixT } = useTranslate('pages.adminTopups')

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger
				render={
					<Button variant="outline" size="sm">
						{prefixT('reject')}
					</Button>
				}
			/>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{prefixT('rejectTitle')}</DialogTitle>
					<DialogDescription>
						{prefixT('rejectDescription')}
					</DialogDescription>
				</DialogHeader>
				<Textarea
					placeholder={prefixT('rejectPlaceholder')}
					value={reason}
					onChange={(e) => setReason(e.target.value)}
				/>
				<DialogFooter>
					<Button
						variant="destructive"
						disabled={pending}
						onClick={() => {
							onReject(reason.trim())
							setOpen(false)
						}}
					>
						{prefixT('reject')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
